<section class="w-full">

    <app-banner_section-type01 [options]="{title:view.title ,imageHref:'https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'}"></app-banner_section-type01>

    <div class="w-full">
        <app-change-game-type01 title="XL Howzit" heading="Your Info-Hub" [features]="view.features"></app-change-game-type01>
    </div>
</section>